import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { connect } from 'react-redux';
import {
  reduxForm, Field, change, getFormValues,
} from 'redux-form';
import Modal from 'react-modal';
import { saveAs } from 'file-saver';
import { routes } from '../../utils/constants';
import {
  getInvoicesByDivision,
  getInvoiceDocument,
  getInvoiceReports,
} from '../../services/invoices';
import {
  apiGetOrderTrackingData,
} from '../TrackShipment/api';
import Dropdown from './Dropdown';
import {
  isRequired,
  dateRangeValidate,
  isAfterNovember2020,
  isAfterToday,
} from '../../utils/validator';
import SortableTableStyled from '../ReactComponent/SortableTableStyled';
import Filter from '../../assets/icons/Filter16x16.svg';
import { ApplyFiltersFooter } from './ApplyFilters';
import {
  CategoryContainer, CategoryTitle, BoxContainer, BoxInfo, DatesContainer,
  SecondaryButton,
  MainTitlesContainer,
  MainTitle,
  MainSubTitle,
  ModalTitle,
  ModalBody,
  ButtonDiv,
  TabsContainer,
  TabContainer,
  FiltersAndTableContainer,
  FiltersContainer,
  ActionsContainer,
} from './css';
import {
  LeftSideBarBodyContainer, TitlesContainer, Title, SubTitle,
} from './ApplyFilters/css';

import Download from '../../assets/icons/Download.svg';
import DatePicker from '../../lib/ui/form_elements/DatePicker';
import {
  putReduxAllRecentInvoices,
  putReduxAllHistoricalInvoices,
  putReduxInvoice,
} from './actions';
import SearchTable from '../ReactComponent/SearchTable';
import RenderField from '../ReactComponent/RenderField';
import {
  formatMoney,
  formatDisplayDate,
  checkBillToAccountProtectedStatus,
  getCurrentLanguage,
  downloadFile,
} from '../../utils/func';
import DownloadReportModal from '../ReactComponent/DownloadReportModal';
import NoDataDecorator from '../ReactComponent/SortableTableStyled/NoDataDecorator';
import { billingAccountTextFormatter } from '../../utils/form';
import Row from '../ReactComponent/Row';
import Column from '../ReactComponent/Column';
import Card from '../ReactComponent/Card';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import LeftSideBar from '../ReactComponent/LeftSideBar';
import {
  formName,
  columns,
  historicalColumns,
  novFirst2020,
  today,
  initialValues,
} from './utils';
import TertiaryButton from '../../lib/ui/buttons/TertiaryButton';
import { colors } from '../../theme/style-helpers';
import { ErrorMessage } from '../ReactComponent/RenderField/css';

const BOX_CONTAINER_MAX_WIDTH = '347px';
const BOX_CONTAINER_MAX_HEIGHT = '226px';

class ManageInvoices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      filterOpen: false,
      dataPerPage: 10,
      activeTab: 0,
      // eslint-disable-next-line react/no-unused-state
      totalPages: [],
      prevFromDate: initialValues.filterFromDate,
      prevToDate: initialValues.filterToDate,
      prevAccountNumbers: this.props.accountNumbers,
      prevFromDateRecent: initialValues.filterFromDate,
      prevToDateRecent: initialValues.filterToDate,
      prevAccountNumbersRecent: this.props.accountNumbers,
      prevFromDateHistorical: initialValues.filterFromDate,
      prevToDateHistorical: initialValues.filterToDate,
      prevAccountNumbersHistorical: this.props.accountNumbers,
      modalIsOpen: false,
      downloadOpen: false,
      historicalVisited: false,
    };
  }

  componentDidMount() {
    const { dispatch, accountNumbers } = this.props;
    dispatch(change(formName, 'filterAccountNumbers', accountNumbers.slice(0, 20)));
    setTimeout(() => {
      this.fetchAllInvoices();
    }, 200);
    checkBillToAccountProtectedStatus(
      this.props.dispatch,
      this.props.division,
      this.props.userId,
      this.props.billingAccounts,
    );
  }

  // TODO: Needs error handling
  /**
   * Fetch invoices for the given filterFromDate, filterToDate date range and filterAccountNumbers collection.
   * Parameter values are defaulted if not supplied.
   * @param params {filterFromDate = "yyyy-MM-dd", filterToDate = "yyyy-MM-dd", filterAccountNumbers = []}.
   */
  fetchAllInvoices = async (params) => {
    const { accountNumbers } = this.props;
    const { activeTab } = this.state;
    // Derive params...
    params = params || {
      filterFromDate: initialValues.filterFromDate,
      filterToDate: initialValues.filterToDate,
      filterAccountNumbers: accountNumbers,
    };

    const fromDate = params.filterFromDate;
    const toDate = params.filterToDate;
    let acctNumbers = params.filterAccountNumbers;

    this.setState({ activeFilters: 2 + acctNumbers.length });

    if (acctNumbers.length > 20) {
      acctNumbers = acctNumbers.slice(0, 20);
    }

    getInvoicesByDivision(acctNumbers, fromDate, toDate)
      .then((response) => {
        if (response.status === 200) {
          const convertedData = this.convertDataFormat(response.data);
          this.setState({ data: convertedData }, () => {
            this.getTotalPages();
          });

          const { putReduxAllRecentInvoices } = this.props;
          putReduxAllRecentInvoices(convertedData);

          this.changeTab(activeTab);
        }
      });
  };

  convertDataFormat = (data) => {
    // data tempering here
    const { billingAccounts } = this.props;
    const sortedData = data.sort(
      (a, b) => Date.parse(b.invoiceDate) - Date.parse(a.invoiceDate),
    );

    return sortedData.map((each) => ({
      invoiceNumber: each.invoiceNumber,
      billingAccount:
        billingAccountTextFormatter(
          billingAccounts.find(
            ({ accountNumber }) => accountNumber === each.accountNumber,
          ),
        )
        || `${each.customerName}${each.accountNumber ? `${` - ${each.accountNumber}`}` : ''
        }`,
      shipmentNumber: each.shipmentNumber,
      invoiceDate: each.invoiceDate && formatDisplayDate(each.invoiceDate),
      dueDate: each.dueDate && formatDisplayDate(each.dueDate),
      invoiceAmount: `${each.invoiceAmount
        && formatMoney(each.invoiceAmount.value)} ${each.invoiceAmount.currencyCode
      }`,
      balanceDue: `${each.balanceDue
        && formatMoney(each.balanceDue.value)} ${each.balanceDue
        && each.balanceDue.currencyCode}`,
      invoiceType: each.invoiceType,
      actions: (
        <Dropdown
          invoiceNumber={each.invoiceId || each.invoiceNumber}
          invoiceType={each.invoiceType}
          transactionSource={each.transactionSource}
          getSingleInvoice={(invoiceNumber, invoiceType, transactionSource) =>
            this.getSingleInvoice(invoiceNumber, invoiceType, transactionSource)}
          shipmentNumber={each.shipmentNumber}
          viewShipment={(shipmentNumber) =>
            this.viewShipment(shipmentNumber)}
        />
      ),
    }));
  };

  viewShipment = (shipmentNumber) => {
    apiGetOrderTrackingData([shipmentNumber], null).then((res) => {
      if (res.data && res.data.orderItems && res.data.orderItems.length > 0) {
        const { orderId } = res.data.orderItems[0];
        window.open(`${routes.viewOrder}?probillNumber=${orderId}`);
      }
    });
  };

  getSingleInvoice = (invoiceNumber, invoiceType, transactionSource) => {
    if (transactionSource === 'CONVERSION') {
      this.setState({ modalIsOpen: true });
    } else {
      getInvoiceDocument(
        invoiceNumber,
        invoiceType,
      ).then((res) => {
        if (res.status === 200) {
          const data = atob(res.data.fileDataAsBase64);
          const byteNumbers = new Array(data.length);
          for (let i = 0; i < data.length; i++) {
            byteNumbers[i] = data.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          saveAs(
            new Blob([byteArray], { type: res.data.mimeType }),
            res.data.fileName,
          );
        }
      });
    }
  };

  getTotalPages = () => {
    const { dataPerPage, data } = this.state;
    const totalPages = [];
    if (data) {
      for (let i = 1; i <= Math.ceil(data.length / dataPerPage); i++) {
        totalPages.push(i);
      }
    }

    // eslint-disable-next-line react/no-unused-state
    this.setState({ totalPages });
  };

  getTabRelativeData = (activeTab) => {
    const { allRecentInvoices, allHistoricalInvoices } = this.props;
    const currentDate = new Date();
    let filteredData = [];
    switch (activeTab) {
      case 1:
        filteredData = allRecentInvoices.filter((invoice) => {
          const currentInvoiceBalanceDueVal = invoice.balanceDue.replace(
            /[^0-9.-]+/g,
            '',
          );
          return (
            new Date(invoice.dueDate.replace(/-/g, '/')) < currentDate
            && currentInvoiceBalanceDueVal > 0
          );
        });
        break;
      case 2:
        // Paid Invoices
        filteredData = allRecentInvoices.filter((invoice) => {
          const currentInvoiceBalanceDueVal = invoice.balanceDue.replace(
            /[^0-9.-]+/g,
            '',
          );
          return currentInvoiceBalanceDueVal <= 0;
        });
        break;
      case 3:
        filteredData = allHistoricalInvoices;
        break;
      case 0:
      default:
        filteredData = allRecentInvoices;
        break;
    }

    return filteredData;
  };

  getSuggestions = (value) => {
    const { activeTab } = this.state;
    const inputValue = value.trim();
    const inputLength = inputValue.length;
    const allData = this.getTabRelativeData(activeTab);
    const filteredData = inputLength === 0
      ? allData
      : allData.filter(
        (item) =>
          (item.invoiceNumber
              && item.invoiceNumber
                .toString()
                .slice(0, inputLength)
                .toLowerCase() === inputValue.toLowerCase())
            || (item.shipmentNumber
              && item.shipmentNumber
                .toString()
                .slice(0, inputLength)
                .toLowerCase() === inputValue.toLowerCase()),
      );
    this.setState({ data: filteredData }, () => this.getTotalPages());
  };

  changeTab = (tabIndex) => {
    const { dispatch } = this.props;
    const {
      activeTab,
      prevFromDateHistorical,
      prevToDateHistorical,
      prevAccountNumbersHistorical,
      prevToDateRecent,
      prevFromDateRecent,
      prevAccountNumbersRecent,
    } = this.state;
    const historical = activeTab === 3;
    const filteredData = this.getTabRelativeData(tabIndex);
    dispatch(change(formName, 'searchByKey', ''));
    if ((historical && tabIndex !== 3) || (tabIndex === 3 && !historical)) {
      if (tabIndex === 3) {
        this.setState(
          {
            prevFromDate: prevFromDateHistorical,
            prevToDate: prevToDateHistorical,
            prevAccountNumbers: prevAccountNumbersHistorical,
          },
          () => {
            dispatch(
              change(formName, 'filterFromDate', this.state.prevFromDate),
            );
            dispatch(change(formName, 'filterToDate', this.state.prevToDate));
            dispatch(
              change(
                formName,
                'filterAccountNumbers',
                this.state.prevAccountNumbers,
              ),
            );
          },
        );
      } else {
        this.setState(
          {
            prevFromDate: prevFromDateRecent,
            prevToDate: prevToDateRecent,
            prevAccountNumbers: prevAccountNumbersRecent,
          },
          () => {
            dispatch(
              change(formName, 'filterFromDate', this.state.prevFromDate),
            );
            dispatch(change(formName, 'filterToDate', this.state.prevToDate));
            dispatch(
              change(
                formName,
                'filterAccountNumbers',
                this.state.prevAccountNumbers,
              ),
            );
          },
        );
      }
    }

    this.setState({ activeTab: tabIndex, data: filteredData }, () =>
      this.getTotalPages(),
    );
  };

  handleSubmitFilter = () => {
    const {
      dispatch,
      formData: { filterFromDate, filterToDate, filterAccountNumbers },
    } = this.props;
    const {
      prevFromDate,
      prevToDate,
      prevAccountNumbers,
      activeTab,
      historicalVisited,
    } = this.state;
    const historical = activeTab === 3;
    dispatch(change(formName, 'searchByKey', ''));

    if (
      filterFromDate !== prevFromDate
      || filterToDate !== prevToDate
      || filterAccountNumbers !== prevAccountNumbers
      || (historical && !historicalVisited)
    ) {
      if (historical) {
        this.setState({
          prevFromDateHistorical: filterFromDate,
          prevToDateHistorical: filterToDate,
          prevAccountNumbersHistorical: filterAccountNumbers,
        });
      } else {
        this.setState({
          prevFromDateRecent: filterFromDate,
          prevToDateRecent: filterToDate,
          prevAccountNumbersRecent: filterAccountNumbers,
        });
      }

      this.fetchAllInvoices({
        filterFromDate,
        filterToDate,
        filterAccountNumbers,
      });
    }

    this.toggleFilter();
  };

  resetFilters = () => {
    const { dispatch } = this.props;
    dispatch(change(formName, 'searchByKey', ''));
    dispatch(change(formName, 'filterFromDate', initialValues.filterFromDate));
    dispatch(change(formName, 'filterToDate', initialValues.filterToDate));
    dispatch(
      change(formName, 'filterAccountNumbers', this.props.accountNumbers.slice(0, 20)),
    );

    this.fetchAllInvoices();
  };

  toggleFilter = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }

    const { filterOpen } = this.state;
    this.setState({ filterOpen: !filterOpen });
  };

  handleDownloadReport = () => {
    this.setState({ downloadOpen: true });
  };

  closeDownloadReport = () => {
    this.setState({ downloadOpen: false });
  };

  handleDownloadSubmit = async ({
    filterFromDate,
    filterToDate,
    filterAccountNumbers,
  }) => {
    const language = getCurrentLanguage();
    await getInvoiceReports(
      filterAccountNumbers,
      filterFromDate,
      filterToDate,
      language,
    ).then((res) => {
      if (res.status === 200) {
        const { fileName, mimeType, fileDataAsBase64 } = res.data;
        const fileType = fileName.includes('.csv') ? '' : '.csv';
        downloadFile({
          dataAsBase64: fileDataAsBase64,
          mimeType,
          filename: fileName + fileType,
        });
      }
    });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  handleModalButtons = (event) => {
    event.preventDefault();

    const {
      target: { name },
    } = event;

    if (name === 'okayButton') {
      this.closeModal();
    }
  };

  renderHeader = ({ heading, description }) => (
    <MainTitlesContainer>
      <MainTitle>{heading}</MainTitle>
      <MainSubTitle>{description.value}</MainSubTitle>
    </MainTitlesContainer>
  );

  render() {
    const {
      rendering: {
        fields: {
          heading,
          description,
          invoiceDownloadWarning,
          referenceInvoiceNumber,
          okay,
        },
      },
      accountNumbers,
      invalid,
      pristine,
      formData,
    } = this.props;

    const {
      activeTab,
      data,
      filterOpen,
      downloadOpen,
      modalIsOpen,
      activeFilters,
    } = this.state;
    const historical = activeTab === 3;
    return (
      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <ModalBody className="justify-content-center">
            <ModalTitle />
            <p>
              {invoiceDownloadWarning.value}
              {' '}
              <a className="link" href="mailto: invreql@dayandrossinc.ca">
                {t('invreql@dayandrossinc.ca')}
              </a>
              {' '}
              {referenceInvoiceNumber.value}
            </p>
            <ButtonDiv className="row">
              <div className="col-sm-12">
                <SecondaryButton
                  onClick={(e) => this.handleModalButtons(e)}
                  className="active"
                  name="okayButton"
                >
                  {okay.value}
                  <span className="icon" />
                </SecondaryButton>
              </div>
            </ButtonDiv>
          </ModalBody>
        </Modal>

        <LeftSideBar
          isOpen={filterOpen}
          toggleMenu={this.toggleFilter}
          footer={(
            <ApplyFiltersFooter
              clearFilters={() => this.resetFilters()}
              applyFilters={() => this.handleSubmitFilter()}
              disabled={
                invalid
                || pristine
                || (formData
                  && formData.filterAccountNumbers
                  && (formData.filterAccountNumbers.length === 0 || formData.filterAccountNumbers.length > 20))
                }
            />
          )}
        >
          <LeftSideBarBodyContainer>
            <TitlesContainer>
              <Title>{t('ApplyFilters')}</Title>
              <SubTitle>{t('ApplyFiltersSubTitle')}</SubTitle>
            </TitlesContainer>

            <CategoryContainer>
              <CategoryTitle>{t('CreatedOn')}</CategoryTitle>
              <DatesContainer>
                <Field
                  name="filterFromDate"
                  type="date"
                  component={DatePicker}
                  className="date-container"
                  initialDate={novFirst2020}
                  maxDate={today}
                  label={t('From')}
                  validate={[
                    isRequired,
                    isAfterNovember2020,
                    isAfterToday,
                    dateRangeValidate,
                  ]}
                />
                <Field
                  name="filterToDate"
                  type="date"
                  component={DatePicker}
                  className="date-container"
                  label={t('To')}
                  initialDate={novFirst2020}
                  maxDate={today}
                  validate={[
                    isRequired,
                    isAfterNovember2020,
                    isAfterToday,
                    dateRangeValidate,
                  ]}
                />
              </DatesContainer>
            </CategoryContainer>

            <CategoryContainer>
              <CategoryTitle>{t('BillingAccount')}</CategoryTitle>
              <BoxContainer
                bgColor={colors.LIGHT_GREY}
                maxWidth={BOX_CONTAINER_MAX_WIDTH}
                maxHeight={BOX_CONTAINER_MAX_HEIGHT}
              >
                <BoxInfo>
                  <Field
                    name="filterAccountNumbers"
                    type="checkboxes"
                    component={RenderField}
                    multiple
                  // verticalList
                    data={accountNumbers}
                    onChange={(e) => { this.setState({ activeFilters: 2 + e.length }); }}
                  />

                </BoxInfo>
              </BoxContainer>
              {formData && formData.filterAccountNumbers && formData.filterAccountNumbers.length > 20 && (
              <ErrorMessage>{t('FilterBillingAccountLimit')}</ErrorMessage>
              )}
            </CategoryContainer>
          </LeftSideBarBodyContainer>

        </LeftSideBar>
        {downloadOpen && (
          <DownloadReportModal
            onClose={this.closeDownloadReport}
            onDownload={this.handleDownloadSubmit}
            title={t('DownloadInvoicesReportTitle')}
            description={t('DownloadInvoicesReportDescription')}
            accountNumbers={accountNumbers}
          />
        )}
        {this.renderHeader({
          heading: heading.value,
          description,
        })}
        <TabsContainer>
          <TabContainer selected={activeTab === 0 && 'active'} onClick={() => this.changeTab(0)}>{t('Invoices')}</TabContainer>
          <TabContainer selected={activeTab === 1 && 'active'} onClick={() => this.changeTab(1)}>{t('OutstandingInvoices')}</TabContainer>
          <TabContainer selected={activeTab === 2 && 'active'} onClick={() => this.changeTab(2)}>{t('PaidInvoices')}</TabContainer>
        </TabsContainer>
        <FiltersAndTableContainer>
          <FiltersContainer>
            <SearchTable
              getSuggestions={this.getSuggestions}
            />
            <ActionsContainer>
              <TertiaryButton
                label={t('DownloadReport')}
                onClick={this.handleDownloadReport}
                size="small"
                showArrow={false}
                iconSrc={Download}
                isIconLeftPosition
              />
              <TertiaryButton
                label={t('Filters') + (activeFilters ? ` (${activeFilters})` : '')}
                onClick={this.toggleFilter}
                size="small"
                showArrow={false}
                iconSrc={Filter}
                isIconLeftPosition
              />
            </ActionsContainer>

          </FiltersContainer>
          {historical && !data ? (
            <div style={{ 'padding-bottom': '100px' }}>
              <Row>
                <Column $tablet={6} $mobile={12} className="mx-auto">
                  <Card desc={t('ManageInvoicesUseFilterDesc')} noHover />
                </Column>
              </Row>
            </div>
          ) : (
            <NoDataDecorator
              component={SortableTableStyled}
              data={data}
              columns={historical ? historicalColumns : columns}
            />
          )}

        </FiltersAndTableContainer>

      </div>
    );
  }
}

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  division: state.profile.division,
  accountNumbers: state.profile.accountNumbers,
  billingAccounts: state.profile.billingAccounts,
  userId: state.profile.userId,
  allRecentInvoices: state.user.invoices,
  allHistoricalInvoices: state.user.historicalInvoices,
});

/*
incoming changes
allInvoices: state.user.invoices,
  isAuthenticated: state.profile.isAuthenticated,
*/
const mdtp = (dispatch) => ({
  putReduxAllRecentInvoices: (allRecentInvoices) =>
    dispatch(putReduxAllRecentInvoices(allRecentInvoices)),
  putReduxAllHistoricalInvoices: (allHistoricalInvoices) =>
    dispatch(putReduxAllHistoricalInvoices(allHistoricalInvoices)),
  putReduxInvoiceByNumber: (invoiceNumber) =>
    dispatch(putReduxInvoice(invoiceNumber)),
});

ManageInvoices = reduxForm({
  form: formName, // a unique identifier for this form
  initialValues,
})(ManageInvoices);

export default connect(
  mstp,
  mdtp,
)(ManageInvoices);

ManageInvoices.propTypes = {
  formData: PropTypes.object,
  division: PropTypes.string,
  accountNumbers: PropTypes.array,
  billingAccounts: PropTypes.array,
  userId: PropTypes.string,
  allRecentInvoices: PropTypes.array,
  allHistoricalInvoices: PropTypes.array,
  putReduxAllRecentInvoices: PropTypes.func,
  dispatch: PropTypes.func,
  invalid: PropTypes.bool,
  pristine: PropTypes.bool,
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      heading: PropTypes.object,
      description: PropTypes.object,
      invoiceDownloadWarning: PropTypes.object,
      referenceInvoiceNumber: PropTypes.object,
      okay: PropTypes.object,
    }),
  }),
};
